export const forbiddenEmails = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'protonmail.com',
  'icloud.com',
  'me.com',
  'msn.com',
  'live.com',
  'yandex.com',
  'mail.ru',
  'zoho.com',
  'gmx.com',
  'inbox.com',
  'rediffmail.com',
  'hushmail.com',
  'tutanota.com',
  'fastmail.com',
  'lycos.com',
  'aim.com',
  'email.com',
  'mail.com',
  'europe.com',
  'consultant.com',
  'engineer.com',
  'post.com',
  'usa.com',
  'india.com',
  'netzero.com',
  'juno.com',
  'myway.com',
  'chello.nl',
  'libero.it',
  'virgilio.it',
  'web.de',
  'rambler.ru',
  'seznam.cz',
  'bol.com.br',
  'terra.com.br',
  'uol.com.br',
  'laposte.net',
  'orange.fr',
  'free.fr',
  't-online.de',
  'bluewin.ch',
  'bellsouth.net',
  'shaw.ca',
  'rogers.com',
  'att.net',
  'sbcglobal.net',
  'sky.com',
  'btinternet.com',
  'ntlworld.com',
  'virginmedia.com',
  'talktalk.net',
  'qq.com',
  '126.com',
  '163.com',
  'sina.com',
  'yeah.net',
  'zoho.eu',
  'zoho.in',
  'runbox.com',
  'disroot.org'
]